export default __webpack_public_path__ + "static/media/Ostali 9.a7904923.jpg";